import * as Constants from "../common/Constants";

const initialState = {
    salesHistory: [],
    isLoading: false,
    isPosting: false,
    isPosted: false,
    error: null
};

export default function userReducer(state = initialState, action) {

    switch (action.type) {

        case Constants.REQUEST_GET_PRODUCTS_SALES_HISTORY:
            var newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = true;
            newState.isPosting = false;

        case Constants.SUCCESS_GET_PRODUCTS_SALES_HISTORY:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = null;
            newState.salesHistory = action.salesHistory;
            return newState;

        case Constants.FAILED_GET_PRODUCTS_SALES_HISTORY:

            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ProductSalesHistoryReducer.js